import React, {useState, useEffect} from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router"
import TutorPageEdit from "../Tutor/TutorPageEdit"

const PublicProfile = () => {
    const {user} = useSelector((state) => state.auth)
    const [option,setOption] = useState(<></>)
    const navigate = useNavigate()
    useEffect(() => {
        if(user.role === "Tutor"){
            setOption(<TutorPageEdit />)
        }else{
            navigate("/")
        }
    }, [])
    return (
        <>  
            <br/>
            <h1>EDITAR PERFIL PÚBLICO</h1>
            <br/>
            {option}
        </>
    )
}

export default PublicProfile